import React from 'react';
import { Routes, Route } from 'react-router-dom';
import App from '../App';
import DXFRandomDrawPage from '../pages/DXFRandomDrawPage';
import WelcomeAirdropPage from '../pages/WelcomeAirdropPage';
import InvestPage from '../pages/InvestPage';
import AdminPanel from './AdminPanel';
import AdminRoute from './AdminRoute';
import { LeaderboardProvider } from '../contexts/LeaderboardContext';

const AppRouter: React.FC = () => {
  return (
    <LeaderboardProvider>
      <Routes>
        {/* Main game route */}
        <Route path="/" element={<App />} />
        <Route path="/verifier" element={<App />} />
        <Route path="/faq" element={<App />} />
        <Route path="/docs" element={<App />} />
        
        {/* DXF Random Daily route */}
        <Route path="/draw" element={<DXFRandomDrawPage />} />

        {/* Investment Agreements route */}
        <Route path="/invest" element={<InvestPage />} />

        {/* Welcome Airdrop Event route */}
        <Route path="/events/welcome-airdrop" element={<WelcomeAirdropPage />} />
        
        {/* Admin route - protected */}
        <Route 
          path="/admin" 
          element={
            <AdminRoute>
              <AdminPanel />
            </AdminRoute>
          } 
        />
        
        {/* Fallback route */}
        <Route path="*" element={<App />} />
      </Routes>
    </LeaderboardProvider>
  );
};

export default AppRouter;